import styled from 'styled-components';

import { StyledControlBarButton } from '../../control-bar-button.styles';

export const StyledRemoveBookmarkButton = styled(StyledControlBarButton)`
  &:hover {
    & svg {
      fill: ${({ theme }) =>
        theme.themeColors.controlBar.rightPanel.icons.bookmarkIcon
          .colorOnFilledAndHover};
    }
    & path {
      stroke: ${({ theme }) =>
        theme.themeColors.controlBar.rightPanel.icons.bookmarkIcon
          .colorOnFilledAndHover};
    }
  }
`;
